import { OktaAuthOptions } from '@okta/okta-auth-js';
import { ConfigClient } from './config';

type CypressWindow = Window & {
    Cypress?: unknown;
    cypressForceAuth?: boolean;
    cypressMockUser?: { sub: string; email: string; name: string };
};

export const getOktaConfig = (window: CypressWindow): OktaAuthOptions => {
    const isCypress = !!window.Cypress;

    return {
        clientId: ConfigClient.oktaClientId(window),
        issuer: ConfigClient.oktaIssuerUrl(window),
        redirectUri: `${window.location.origin}/login/callback`,
        scopes: ['openid', 'profile', 'email', 'offline_access', 'groups'],
        // Configure token manager for Cypress to skip validation completely
        ...(isCypress
            ? {
                  tokenManager: {
                      autoRenew: false,
                      storage: 'memory',
                      // Disable all token validation
                      expireEarlySeconds: 0,
                  },
                  // Disable PKCE and other features that require validation
                  pkce: false,
                  // TECHNICAL DEBT: ignoreSignature is an internal/undocumented Okta option.
                  // This may break after Okta SDK upgrades. If this breaks, consider:
                  // 1. Removing this option and relying on CypressSecurityMock to bypass Okta entirely
                  // 2. Finding a supported configuration option in newer SDK versions
                  // 3. Mocking at the network level instead of SDK configuration
                  ignoreSignature: true,
              }
            : {}),
    };
};
